// extracted by mini-css-extract-plugin
export default {"card":"Card_card__jiL6i","overlay":"Card_overlay__GP9Zn"};